import type { ProjectsListTableRowActionsProps } from "./projects-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import { ProjectsListTableRowActions } from "./projects-list-table-row-actions.component";

export const ProjectsListTableRowActionsWrapper = ({
  project,
}: ProjectsListTableRowActionsProps) => {
  return (
    <ListTableRowActions>
      <ProjectsListTableRowActions project={project} />
    </ListTableRowActions>
  );
};
